import { LoaderIcon } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Skeleton } from '@/components/ui/skeleton';
export function TableActionSkeleton() {
  return <div className="p-5 bg-white">
      <Alert className="space-y-4">
        <LoaderIcon color="rgb(0, 30, 113)" className="text-primary h-4 w-4 animate-spin" />
        <AlertTitle>
          <div className="space-y-2">
            <Skeleton className="bg-secondary-readable/[0.25] h-2 w-[200px]" />
            <Skeleton className="bg-secondary-readable/[0.25] h-2 w-[250px]" />
          </div>
        </AlertTitle>
        <AlertDescription>
          <div className="space-y-2">
            <Skeleton className="bg-secondary-readable/[0.25] h-2 w-[200px]" />
            <Skeleton className="bg-secondary-readable/[0.25] h-2 w-[250px]" />
          </div>
        </AlertDescription>
      </Alert>
    </div>;
}